import React, { Component } from 'react';

import AppStore from '../flux/AppStore';
import {__} from "../Translator";
import Footer from "../components/Footer";
import Header from "../components/Header";
import StepIndicator from "../components/StepIndicator";

import './ThankYou.css';
import OnlinePurchaseStore from '../flux/OnlinePurchaseStore';

class ThankYouScreen extends Component {
  constructor(props) {
    super(props);

    this.state = {
      customProduct: AppStore.getCustomProduct(),
      online_purchase: OnlinePurchaseStore.getState(),
    };


    /*this.props.navigation.onBack(() => {
      this.props.navigation.navigate('configurator');
    });*/

    this.onCustomProductUpdate = this.onCustomProductUpdate.bind(this);
  }

  componentDidMount() {
    AppStore.events.updateCustomProduct.addListener(this.onCustomProductUpdate);
  }

  componentWillUnmount() {
    AppStore.events.updateCustomProduct.removeListener(this.onCustomProductUpdate);
  }

  onCustomProductUpdate() {
    this.setState({ customProduct: AppStore.getCustomProduct() });
  }

  render() {
    return (
      <div>
        <Header
          title={__('Configurator')}

        />

        <Footer  showBackButton={false} navigation={this.props.navigation} />

        <StepIndicator currentScreen={this.props.navigation.currentScreen} />

        <div className="main">
          <div className="row">
            <div className="col-xs-8 col-xs-offset-2 text-center">
            <div className="main__hero">
              <h1 className="hero__title">{__('Thank you!')}</h1>
              <div className="hero__text">
                <div>
                  <p>{__('for submitting your design')}</p>
                </div>
              </div>

              </div>
              <div className="thankYou__text">
                {this.state.online_purchase === true ? (
                  <span>
                    {__('A member of our Custom Works Consumer Care team will contact you shortly to confirm your design and talk you through the ordering process.')}<br />
                    {__('Please use the below reference code:')}
                      <span className="customizationHash__code thankYou">
                        {this.state.customProduct.hash}
                      </span>
                  </span>
                ):(
                  <span>
                    {__('We have submitted your design to your preferred store.')}<br />
                    {__('They will contact you in order to arrange an appointment.')}<br />
                    {__('Please use the below reference code:')}
                    <span className="customizationHash__code thankYou">
                      {this.state.customProduct.hash}
                    </span>
                    {__('Please allow 72 hours for the store to contact you, if you have not heard anything after that please contact us directly HERE so we can assist you.')}
                  </span>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}
export default ThankYouScreen;



// WEBPACK FOOTER //
// ./src/screens/ThankYou.js